import { PhoneFormatPipe } from 'src/app/components/shared/shared.service';
import { ChangeDetectorRef, Component, inject, computed, ChangeDetectionStrategy } from '@angular/core';
import { CallState, RingcentralWebphone } from '../ringcentral-webphone.service';
import { takeWhile } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { IncomingCallService } from '../incoming-call.services';
import { NumpadModalComponent } from '../../pages/sales/my-leads-details/leads-communication/numpad-modal/numpad-modal.component';

@Component({
    selector: 'app-active-call-widget',
    imports: [CommonModule, RouterModule, PhoneFormatPipe],
    templateUrl: './active-call-widget.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './active-call-widget.component.scss'
})
export class ActiveCallWidgetComponent {
    private alive: boolean = true;
  private cdr = inject(ChangeDetectorRef);
  public phone = inject(RingcentralWebphone);
  private modalService = inject(BsModalService);
  private incomingCallService = inject(IncomingCallService);
  callState = CallState;

  timer: any = 0;
  details: any;
  selectedPracticeMobile2 = '';
  incomingSession: any;
  
  // Expose activeSessionsList as a callable function for template, filtering out ended sessions and ringing inbound calls
  get activeSessionsList() {
    return () => this.phone.activeSessionsList().filter(s => {
      // Filter out ended/failed sessions
      if (s.state === CallState.ENDED || s.state === CallState.FAILED) return false;
      // Filter out ringing inbound calls (they show in the incoming call modal instead)
      if (s.type === 'inbound' && s.state === CallState.RINGING) return false;
      return true;
    });
  }


  ngOnInit(): void {
    this.phone.timer$.pipe(takeWhile(() => this.alive)).subscribe((res) => {
      if(res){
        this.timer = res;
        this.cdr.detectChanges();
      }
    })

    this.incomingCallService.incomingCall$
      .pipe(takeWhile(() => this.alive))
      .subscribe((session) => {
        this.incomingSession = session;
      });
  }
  

  isGlobalWidgetExpanded = false;
  get shouldShowFloatingIcon(): boolean {
    const sessions = Object.values(this.phone.activeSessions());
    if (sessions.length === 0) {
      const globalState = this.phone.callState();
      // Only show for outbound ringing or connected/conference calls
      const shouldShowFromGlobal = [
        this.callState.CONNECTED,
        this.callState.CONFERENCE
      ].includes(globalState);
      return shouldShowFromGlobal;
    }

    const hasVisibleSession = sessions.some(session => {
      // Filter out ended/failed sessions
      if (session.state === CallState.ENDED || session.state === CallState.FAILED) return false;
      // Inbound calls: only show if connected or in conference (ringing ones show in incoming modal)
      if (session.type === 'inbound') {
        return session.state === CallState.CONNECTED;
      }
      // Outbound calls: show for all active states
      return true;
    });

    return hasVisibleSession;
  }


  formattedTime(duration?: number): string {
    return this.phone.formattedTime(duration !== undefined ? duration : this.timer);
  }


  openAddCallModal() {}

  openActiveCallLeadDetails(): void {}

  trackBySessionId(index: number, session: any): string {
    return session.id;
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
